import Cookies from 'js-cookie';

import { AVOID_CDN_COOKIE_NAME } from '@/atoms/cdn';
import { USER_STATE_COOKIE_NAME } from '@/constants/cookies';
import { getUniversalCookie } from '@/cookies';

import type { NextIncomingMessage } from '@/types/request';

export const shouldAvoidCdn = (req?: NextIncomingMessage) => {
  // Check the new dedicated cookie first
  if (req) {
    // Server-side: check both the new cookie and legacy cookie
    const newCookie = getUniversalCookie<string>(AVOID_CDN_COOKIE_NAME, {
      req,
    });
    if (String(newCookie) === '1') {
      return true;
    }

    // Fallback to legacy cookie for backward compatibility during rollout
    const legacyCookie = getUniversalCookie<{ avoidCdn?: number }>(
      USER_STATE_COOKIE_NAME,
      { req }
    );
    return !!legacyCookie?.avoidCdn;
  }

  // Client-side: check the new dedicated cookie
  const value = Cookies.get(AVOID_CDN_COOKIE_NAME);
  if (value === '1') {
    return true;
  }

  // Fallback to legacy cookie
  const legacyCookie = getUniversalCookie<{ avoidCdn?: number }>(
    USER_STATE_COOKIE_NAME
  );
  return !!legacyCookie?.avoidCdn;
};
